import { productsFromStore } from './products-from-store.js';
import { productAddData } from './product-add-data.js';

export function createProductAdd(storeItems) {
    return productsFromStore(storeItems)
        .then((products) => productAddData(products));
}
